import { Locales, LocaleMessages, ServerConfig } from 'shared-types';

interface Params {
  language?: Locales;
  messages: LocaleMessages;
  serverConfig: ServerConfig<'admin'>;
}

const getExcelCoursesColumnOptions = ({
  language,
  messages,
  serverConfig
}: Params) => {
  const customAttributeOptions: { [key: string]: string } = {};

  serverConfig.courseCustomAttributes
    ?.filter((attr) => attr.displayInAnalytics)
    .forEach((attr) => {
      customAttributeOptions[`product.customAttributes.${attr.key}`] =
        attr.titleData?.[language || serverConfig.defaultSystemLanguage] ||
        attr.title;
    });

  return {
    'product.title': messages.commonCourse,
    'product.categories': messages.commonCategories,
    'product.completionWorkload': `${messages.excelWorkload} (${messages.completionWorkloadHours})`,
    ...(serverConfig.workloadInDays
      ? {
          'product.workloadInDays': `${
            messages.excelWorkload
          } (${messages.commonDays.toLowerCase()})`
        }
      : {}),
    'product.user.isMandatory': messages.commonMandatory,
    'product.user.status': messages.commonStatus,
    'product.user.completionDate': messages.completionsCompletionDate,
    'product.user.expirationDate': messages.commonExpirationDate,
    'product.user.electronicSignatureText':
      messages.completionElectronicSignature,
    'product.user.tasksProgress': messages.excelTasksProgress,
    'product.user.readingProgress': messages.excelReadingProgress,
    'product.user.videoProgress': messages.excelVideoProgress,
    ...(serverConfig.videoRequirementsType === 'individual'
      ? {
          'product.user.videoProgressVideosWatched':
            messages.completionsVideosWatched
        }
      : {}),
    ...customAttributeOptions
  };
};

export default getExcelCoursesColumnOptions;
